import { computed } from 'vue';
import { mainPage } from '@/api/mainPage';
import { store } from '@/store';
import types from '@/store/types';
import toast from '@kk/toast';
import { throttle } from '@kk/utils';

async function getMainPageData () {
  const shareCode = computed(() => store.state.shareCode);
  try {
    const { code, message, data } = await mainPage(shareCode.value);
    loading.hide();
    if (code == 200) {
      if (data.team) {
        store.commit(types.SET_CURRENT_MEMBER, data.team.members);
        store.commit(types.SET_TEAM_LEADER, data.team.teamLeaderUid);
        store.commit(types.SET_TEAM_MIN_OBTAIN, data.team.teamRankCount);
      }
      if (data.shareExtendInfo) {
        store.commit(types.SET_JOINED_TEAM, data.shareExtendInfo.joinedTeam);
        store.commit(types.SET_SHARE_EXTRA_INFO, data.shareExtendInfo);
      }

      store.commit(types.SET_ASSIST_RULE, data.rule);
      store.commit(types.SET_HEADER_INFO, {
        bannerForNoTeam: data.bannerForNoTeam,
        bannerForTeam: data.bannerForTeam,
        period: data.period
      });
      store.commit(types.SET_PREVIEW_PRIZE_STATUS, data.previousPeriodObtainFlag);
      store.commit(types.SET_PREVIEW_PRIZE_NUMBER, data.previousPeriodObtainCount);
      store.commit(types.SET_HOST, data.host);
      if (!store.state.pageDataReady) {
        store.commit(types.SET_PAGE_DATA_READY);
      }
    } else {
      toast.show({
        text: message || '服务器错误',
        time: 1500,
      });
      console.log(message || '服务器错误');
    }
  } catch (error) {
    const errorMsg = (error as Error).message || '服务器错误';
    loading.hide();
    toast.show({
      text: errorMsg,
      time: 1500,
    });
    console.error('error in getMainPageData', error);
  }
}

const throttleGetMainPageData = throttle(getMainPageData, 1000, true);

export function useUpadeMainPageData () {
  throttleGetMainPageData();
}
